module.exports = __webpack_public_path__ + "static/media/1017124.88f0f40e.png";